import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import ContactPopup from "../customComponent/ContactPopup";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);

  const handleClosePopup = () => setPopUpOpen(false);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about-glowtech-solutions" },
    { name: "Services", href: "/glowtech-services" },
    { name: "Blogs", href: "/glowtech-blogs" },
    { name: "Careers", href: "/glowtech-careers" },
    { name: "Contact", href: "/contact-glowtech-solutions" },
  ];

  return (
    <header className="w-full fixed top-0 z-50">
      {/* Top Bar */}
      <div className="bg-blue-100 text-sm text-gray-700 px-12 py-2 flex flex-col md:flex-row justify-between items-center gap-2">
        {/* <div className="flex items-center space-x-3 text-base font-medium">
          <a
            href="https://www.facebook.com/profile.php?id=61572863939608"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.linkedin.com/company/glowtech-solutions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/yourprofile"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
        </div> */}
        <div className="flex flex-col items-center text-base font-medium md:flex-row md:justify-end md:gap-4 text-center md:text-right">
          <span>Contact: 788-897-4447</span>
          <span>Inquiries: contact@glowtechsolutions.in</span>
        </div>

        <button
          className="bg-[#276191] text-white text-base font-bold px-4 py-1 rounded hover:bg-blue-900"
          onClick={() => setPopUpOpen(true)}
        >
          GET A FREE QUOTE
        </button>
      </div>

      {/* Main Navbar */}
      <nav className="bg-[#0C1832] text-white">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <Link to="/">
              <img
                src="/logo-with-name.webp"
                alt="Glowtech Logo"
                className="h-10 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Nav Links */}
          <ul className="hidden md:flex gap-10 items-center">
            {navLinks.map((link, idx) => {
              return (
                <li key={idx}>
                  <NavLink
                    to={link.href}
                    className={({ isActive }) =>
                      `relative inline-block py-1 text-lg font-semibold tracking-wide transition duration-300 ease-in-out
                       text-white hover:text-[#59a0ce] ${
                         isActive
                           ? "text-[#59a0ce] border-b-2 border-[#59a0ce]"
                           : ""
                       }`
                    }
                  >
                    {link.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>

          {/* Mobile Toggle Button */}
          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Nav Menu */}
        {menuOpen && (
          <ul className="md:hidden bg-[#0C1832] px-4 pb-4 space-y-2 text-center">
            {navLinks.map((link, idx) => {
              // No dropdown for "Services" on mobile
              return (
                <li key={idx}>
                  <NavLink
                    to={`${link.href}`}
                    className={({ isActive }) =>
                      `relative block px-3 py-1 text-xl font-semibold tracking-wide transition duration-300 ease-in-out
       text-white hover:text-[#59a0ce] ${isActive ? "text-[#59a0ce]" : ""} 
       after:content-[''] after:absolute after:left-1/2 after:bottom-0 after:h-0.5 after:bg-[#59a0ce] 
       after:transform after:-translate-x-1/2 after:rounded-full 
       after:transition-all after:duration-300 
       ${isActive ? "after:w-full" : "after:w-0 hover:after:w-full"}`
                    }
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </nav>

      {popUpOpen && <ContactPopup onClose={handleClosePopup} />}
    </header>
  );
};

export default Header;
